import $ from 'jquery'
import md5hex from 'md5-hex'
import memoize from 'lodash-es/memoize'
import { MessageOverlay } from './message-overlay'
import { Popup } from './popup'
import { Filter } from './filter'
import { PopMenu } from './pop-menu'
import { extractMessageFromAjaxFailure } from './ajax-error'

const md5 = memoize(md5hex)
const debug = require('debug')('pm:users')

export const MSG_ADMIN_ENABLED = 'pm:admin-enabled'
export const MSG_ADMIN_DISABLED = 'pm:admin-disabled'
export const MSG_ADMIN_SAVED = 'pm:admin-saved'

export const Users = {
  HOOK_SET_ADMIN_FORM: '.js-set-admin-form',
  HOOK_SERVER_ACCESS: '.js-server-access',
  HOOK_SERVER_ACCESS_FORM: '.js-set-server-access', // Used for server access that makes a request
  HOOK_SERVER_ACCESS_STATIC: '.js-set-server-access-static', // Used for static form on invite page
  HOOK_SERVER_ACCESS_APPLY_FORM: '.js-apply-access-all',
  HOOK_SERVER_ACCESS_VALUE: '.js-server-access-value', // Hidden input used to set server states on invite page
  HOOK_DIGEST_ENABLE: '.js-digest-enable-all',
  HOOK_DIGEST_DISABLE: '.js-digest-disable-all',
  HOOK_DIGEST_TOGGLE: '.js-digest-toggle',
  HOOK_INVITE_RESEND: '.js-resend-invite',

  init: function () {
    Users.renderAvatars()

    $(document).on('filter-items-loaded', Users.filterItemsLoaded)
    $(document).on('click', Users.HOOK_INVITE_RESEND, Users.resendInvite)
    $(document).on('change', Users.HOOK_SERVER_ACCESS_FORM, Users.setAccess)
    $(document).on('submit', Users.HOOK_SET_ADMIN_FORM, Users.setAdminForm)
    $(document).on(
      'click',
      Users.HOOK_SERVER_ACCESS_STATIC + ' input[type="radio"]',
      Users.setAccessStatic
    )
    $(document).on(
      'submit',
      Users.HOOK_SERVER_ACCESS_APPLY_FORM,
      Users.applyAllAccess
    )
    $(document).on(
      'click',
      Users.HOOK_DIGEST_ENABLE,
      { enableAll: true },
      Users.toggleAllDigests
    )
    $(document).on(
      'click',
      Users.HOOK_DIGEST_DISABLE,
      { enableAll: false },
      Users.toggleAllDigests
    )
    $(document).on('change', Users.HOOK_DIGEST_TOGGLE, Users.toggleDigest)
  },

  filterItemsLoaded: function (event, data) {
    // More servers are loaded
    if (data.filterID === 'invite-servers') {
      const $serverAccessValue = $(Users.HOOK_SERVER_ACCESS_VALUE)

      if (!$serverAccessValue.length) {
        // we are not on the invite page!
        return
      }

      const accessValue = $serverAccessValue.val()

      // If access was previously applied to all, update the newly loaded server states
      if (accessValue.length > 0) {
        const accessLabel = $serverAccessValue.attr('data-label')
        Users.updateAccessDropdowns(accessLabel, accessValue, true)
      }
    }
  },

  toggleAllDigests: function (event) {
    event.preventDefault()

    // Make sure the button isn't disabled
    if (!$(this).hasClass('is-disabled')) {
      $('.servers_content').addClass('u-is-loading')

      const $checkboxes = $(Users.HOOK_DIGEST_TOGGLE)
      event.data.enableAll
        ? $checkboxes.prop('checked', true)
        : $checkboxes.prop('checked', false)
      Users.toggleDigestButtonState(event.data.enableAll)

      $.ajax({
        url: $(this).attr('href'),
        data: { enable_all: event.data.enableAll },
        method: 'PUT',
      })
        .done(function () {
          MessageOverlay.show('Saved successfully.')
        })
        .fail(function () {
          MessageOverlay.show('There was an error.', 'error')
        })
        .always(function () {
          $('.servers_content').removeClass('u-is-loading')
        })
    }
  },

  toggleDigestButtonState: function (enableAll) {
    const disabledClass = 'is-disabled'

    if (enableAll) {
      $(Users.HOOK_DIGEST_ENABLE).addClass(disabledClass)
      $(Users.HOOK_DIGEST_DISABLE).removeClass(disabledClass)
    } else {
      $(Users.HOOK_DIGEST_ENABLE).removeClass(disabledClass)
      $(Users.HOOK_DIGEST_DISABLE).addClass(disabledClass)
    }
  },

  toggleDigest: function () {
    const disabledClass = 'is-disabled'

    $.ajax({
      url: $(this).attr('data-uri'),
      data: $(this).prop('checked'),
      method: 'PUT',
    })
      .done(function () {
        MessageOverlay.show('Saved successfully.')
        $(Users.HOOK_DIGEST_ENABLE).removeClass(disabledClass)
        $(Users.HOOK_DIGEST_DISABLE).removeClass(disabledClass)
      })
      .fail(function () {
        MessageOverlay.show('There was an error.', 'error')
      })
  },

  setAdminForm: function (event) {
    event.preventDefault()

    const $form = $(this)
    $form.addClass('u-is-loading')

    $.ajax({
      url: $form.attr('action'),
      method: 'PUT',
    }).done(function () {
      Popup.close(event)
      window.postMessage(MSG_ADMIN_ENABLED)
      window.postMessage(MSG_ADMIN_SAVED)
    })
  },

  enableAccountAdmin: function () {
    $(Users.HOOK_SERVER_ACCESS).slideUp()
  },

  disableAccountAdmin: function () {
    // Update all access dropdowns to no access
    Users.updateAccessDropdowns('No access', 'none')

    // Show access list
    $(Users.HOOK_SERVER_ACCESS).slideDown()
  },

  applyAllAccess: function (event) {
    event.preventDefault()

    // Find selected element
    const $selected = $(this).find('input:checked')

    // Close popup
    Popup.close(event)

    // Remember access role so we can set the state when showing more servers
    $(Users.HOOK_SERVER_ACCESS_VALUE)
      .attr('data-label', $selected.attr('data-label'))
      .val($selected.val())

    // Update access dropdowns
    Users.updateAccessDropdowns($selected.attr('data-label'), $selected.val())
  },

  updateAccessDropdowns: function (labelText, radioValue, targetNewServers) {
    function update(el) {
      // Set radio value and text labels
      $(el).find('.js-pop-menu_trigger').text(labelText)
      $(el)
        .find('.o-radio-select_input[value="' + radioValue + '"]')
        .prop('checked', true)

      const $serverTitle = $(el).find('.server-title')
      const disabledClass = 'server-title--disabled'

      // Update text and set class if no access is set
      radioValue === 'none'
        ? $serverTitle.addClass(disabledClass)
        : $serverTitle.removeClass(disabledClass)
    }

    if (targetNewServers) {
      // Only update newly loaded servers
      update(Filter.HOOK_ITEM + '[data-batch="' + Filter.item_batch + '"]')
    } else {
      // Update all servers
      update('.server-list_item')
    }
  },

  setAccess: function () {
    const $form = $(this)

    // Serialize data before disabling props
    const data = $form.serialize()

    // Disable inputs so they can't be clicked on while loading
    $form.find('input').prop('disabled', true)

    // Set loading state
    $form.addClass('u-is-loading')

    const $selected = $form.find('input:checked')
    const $serverTitle = $form
      .parents('.server-list_item')
      .find('.server-title')

    $.ajax({
      url: $form.attr('action'),
      data: data,
      method: 'PUT',
    })
      .done(function () {
        // Close popup and remove loading state
        PopMenu.closeAll()

        // Disable row if they set no access
        if ($selected.val() === 'none') {
          $serverTitle.addClass('server-title--disabled')
        } else {
          $serverTitle.removeClass('server-title--disabled')
        }

        // Set dropdown state
        $form
          .parents(PopMenu.HOOK_ROOT)
          .find(PopMenu.HOOK_TRIGGER)
          .text($selected.attr('data-label'))

        MessageOverlay.show('Saved successfully.')
      })
      .fail(function () {
        MessageOverlay.show(
          'There was an error changing server access. Please try again.',
          'error'
        )
      })
      .always(function () {
        $form.find('input').prop('disabled', false)
        $form.removeClass('u-is-loading')
      })
  },

  setAccessStatic: function () {
    PopMenu.closeAll()
    const $item = $(this).parents('.server-list_item')

    if ($(this).val() === 'none') {
      $item.find('.server-title').addClass('server-title--disabled')
    } else {
      $item.find('.server-title').removeClass('server-title--disabled')
    }

    $item.find('.js-pop-menu_trigger').text($(this).attr('data-label'))
  },

  renderAvatars: function () {
    debug('renderAvatars')
    const dpi = window.devicePixelRatio || 1

    $('.js-avatar').each(function (i, el) {
      const $el = $(el)
      const email = $el.attr('data-avatar-email')
      $el.removeAttr('data-avatar-email')
      const name = $el.attr('data-user-name')
      $el.removeAttr('data-user-name')

      if (email) {
        debug(' injecting avatar image for', email)
        $el.find('.u-avatar_photo').remove()

        const emailMD5 = md5(email)
        const size = $el.width() || 128
        const $img = $('<img />')
          .attr(
            'src',
            'https://secure.gravatar.com/avatar/' +
              emailMD5 +
              '?s=' +
              size +
              '&d=blank'
          )
          .addClass('u-avatar_photo')

        // Use srcset attribute on high density displays
        if (dpi > 1) {
          $img.attr(
            'srcset',
            'https://secure.gravatar.com/avatar/' +
              emailMD5 +
              '?s=' +
              size * dpi +
              '&d=blank 2x'
          )
        }

        $img.attr('alt', name)

        $img.prependTo(el)
      }
    })
  },

  resendInvite: function (event) {
    event.preventDefault()

    const $el = $(this)
    $el.addClass('is-loading')

    $.ajax({
      url: $el.attr('href'),
      method: 'PUT',
      dataType: 'json',
    })
      .done(function () {
        $el.fadeOut()
        MessageOverlay.show('Invite sent!')
      })
      .fail(function (jqXHR) {
        $el.removeClass('is-loading')

        const message = extractMessageFromAjaxFailure(
          jqXHR,
          'There was a problem resending the invite. Please try again.'
        )

        MessageOverlay.show(message, 'error')
      })
  },
}

window.addEventListener('message', function handleMessage(e) {
  switch (e.data) {
    case MSG_ADMIN_DISABLED:
      debug('handleMessage', e)
      Users.disableAccountAdmin()
      break

    case MSG_ADMIN_ENABLED:
      debug('handleMessage', e)
      Users.enableAccountAdmin()
      break

    case MSG_ADMIN_SAVED:
      debug('handleMessage', e)
      MessageOverlay.show('Saved successfully.')
      break
  }
})

$(Users.init)
